import Vue from 'vue';
import Vuetify, {
  VSnackbar, VBtn, VIcon, VBreadcrumbs,
} from 'vuetify/lib';
import VuetifyToast from 'vuetify-toast-snackbar';


Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
    VBreadcrumbs,
  },
});

Vue.use(VuetifyToast, {
  timeout: 10000,
  queueable: true,
  dismissable: false,
  showClose: true,
  closeIcon: 'mdi-close',
  x: 'center',
  y: 'bottom',
});

export default new Vuetify({});
